import { render } from "./GraphicDesignA.vue?vue&type=template&id=804c31a2&scoped=true"
import script from "./GraphicDesignA.vue?vue&type=script&lang=js"
export * from "./GraphicDesignA.vue?vue&type=script&lang=js"

import "./GraphicDesignA.vue?vue&type=style&index=0&id=804c31a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-804c31a2"]])

export default __exports__